// Metadata for this Writing, co-located with the demo it describes.
// The Writing list is built by globbing */meta.tsx (see ../registry.ts), so a demo
// appears by existing and disappears by being deleted — no central array to update.
// `listed: false` keeps the route and its capsule while hiding it from the list.
import { Icons } from '#app/components/icons.tsx'

export const demo = {
	title: 'Why the model is for reasoning and code is for computation',
	blurb:
		'A model is a judgment engine, not a calculator. Where that line falls decides which half of a ledger it is allowed to touch.',
	label: 'Architecture',
	eyebrow: 'The harness',
	href: '/writing/harness',
	listed: true,
	dates: '2024 - Present',
	active: true,
	featured: true,
	description:
		'The model never writes a ledger row. It proposes inputs — classified transactions, matched sources, entries extracted from messy evidence — and the deterministic engine regenerates the ledger from them: double-entry must balance, every figure traces to an event and a rule, and a wrong proposal is deleted and rebuilt, not patched (Claude Code plus domain skills). That is how non-deterministic AI reasoning coexists with a ledger that has to survive a tax audit. The architecture diagram lays out where that boundary sits; the same pattern, pointed at code instead of accounting, is one of several kinds of harness.',
	hardProblem:
		'A model can tell you that a CSV export, a screenshot and an API response describe the same transfer, and cannot be relied on to total them. A ledger needs both halves, and needs to know which one produced any given figure.',
	approach:
		'Put the line where the capability changes. The model proposes inputs — classified transactions, matched sources, entries pulled from messy evidence — and the deterministic engine regenerates the ledger from them. A wrong proposal is deleted and rebuilt, never patched.',
	technologies: [
		'Claude Code',
		'Agentic AI',
		'Structured output',
		'Evals',
		'TypeScript',
	],
	links: [
		{
			type: 'Architecture',
			href: '/writing/harness',
			icon: <Icons.globe className="size-3" />,
		},
		{
			type: 'Types of harness',
			href: '/writing/types-of-agentic-harness',
			icon: <Icons.globe className="size-3" />,
		},
	],
	video: '',
}
